import React, { useState } from 'react';

function FAQ() {
  const [activeCategory, setActiveCategory] = useState('geral');

  const faqData = {
    geral: [
      {
        question: "¿Cómo creo una cuenta?",
        answer: "Haz clic en el botón 'Entrar' en el encabezado y luego en 'Crear Cuenta'. Completa tus datos personales y confirma tu email."
      },
      {
        question: "Olvidé mi contraseña, ¿qué hago?",
        answer: "En la página de inicio de sesión, haz clic en 'Olvidé mi contraseña' y sigue las instrucciones para restablecer tu contraseña."
      },
      {
        question: "¿Cómo cambio mis datos personales?",
        answer: "Accede a tu cuenta a través del menú 'Mi Cuenta' y haz clic en 'Editar Perfil' para hacer cambios."
      }
    ],
    pedidos: [
      {
        question: "¿Cómo hago un pedido?",
        answer: "Navega por los productos, agrégalos al carrito, elige color y tamaño, y finaliza la compra en el checkout."
      },
      {
        question: "¿Qué formas de pago aceptan?",
        answer: "Aceptamos tarjetas de crédito/débito, transferencias bancarias y pago vía WhatsApp."
      },
      {
        question: "¿Puedo cancelar un pedido?",
        answer: "Sí, puedes cancelar hasta 2 horas después de la confirmación. Contáctanos inmediatamente."
      }
    ],
    entrega: [
      {
        question: "¿Cuál es el plazo de entrega?",
        answer: "Región Metropolitana: 1-2 días hábiles. Otras regiones: 3-7 días hábiles."
      },
      {
        question: "¿Cuál es el costo del envío?",
        answer: "Envío gratis para compras arriba de $50. Abajo de eso, el costo varía según tu región."
      },
      {
        question: "¿Entregan en todo Paraguay?",
        answer: "¡Sí! Entregamos en todo Paraguay a través de transportadoras asociadas."
      }
    ],
    devolucoes: [
      {
        question: "¿Cuál es el plazo para devolución?",
        answer: "30 días a partir de la fecha de recepción del producto."
      },
      {
        question: "¿Cómo solicito una devolución?",
        answer: "Contáctanos vía WhatsApp, email o teléfono para iniciar el proceso."
      },
      {
        question: "¿Cuánto tiempo tarda el reembolso?",
        answer: "El reembolso se procesa en hasta 14 días hábiles después de recibir el producto."
      }
    ]
  };

  const categories = [
    { id: 'geral', name: 'General', icon: 'fas fa-question-circle' },
    { id: 'pedidos', name: 'Pedidos', icon: 'fas fa-shopping-cart' },
    { id: 'entrega', name: 'Entrega', icon: 'fas fa-truck' },
    { id: 'devolucoes', name: 'Devoluciones', icon: 'fas fa-undo' }
  ];

  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      padding: '40px 0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-5 fw-bold text-dark mb-3">
                Preguntas Frecuentes
              </h1>
              <p className="lead text-muted">
                Encuentra respuestas a las dudas más comunes sobre nuestros productos y servicios.
              </p>
            </div>

            {/* Category Navigation */}
            <div className="mb-5">
              <div className="row g-2">
                {categories.map((category) => (
                  <div key={category.id} className="col-6 col-md-3">
                    <button
                      className={`btn w-100 ${activeCategory === category.id ? 'btn-primary' : 'btn-outline-secondary'}`}
                      onClick={() => setActiveCategory(category.id)}
                    >
                      <i className={`${category.icon} me-2`}></i>
                      {category.name}
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* FAQ Content */}
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <h3 className="fw-bold text-dark mb-4">
                  {categories.find(c => c.id === activeCategory)?.name}
                </h3>

                <div className="accordion" id={`faq-${activeCategory}`}>
                  {faqData[activeCategory]?.map((item, index) => (
                    <div key={index} className="accordion-item border mb-2">
                      <h2 className="accordion-header" id={`heading-${activeCategory}-${index}`}>
                        <button
                          className="accordion-button collapsed bg-white text-dark"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${activeCategory}-${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse-${activeCategory}-${index}`}
                        >
                          {item.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse-${activeCategory}-${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading-${activeCategory}-${index}`}
                        data-bs-parent={`#faq-${activeCategory}`}
                      >
                        <div className="accordion-body">
                          {item.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Contact Section */}
                <div className="text-center mt-5">
                  <div className="card bg-light border-0">
                    <div className="card-body p-4">
                      <h4 className="fw-bold text-dark mb-3">
                        ¿Aún tienes dudas?
                      </h4>
                      <p className="mb-4">
                        ¡Nuestro equipo está listo para ayudar! Contáctanos.
                      </p>
                      <div className="row g-3 justify-content-center">
                        <div className="col-md-4">
                          <a href="https://wa.me/595211234567" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg w-100">
                            <i className="fab fa-whatsapp me-2"></i>
                            WhatsApp
                          </a>
                        </div>
                        <div className="col-md-4">
                          <a href="mailto:contacto@asmarshop.com" className="btn btn-primary btn-lg w-100">
                            <i className="fas fa-envelope me-2"></i>
                            Email
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
